<template>
    <v-container fluid>   
      <LeftMenu/>     
        <v-layout row wrap>   
          <v-flex xs1></v-flex>
          <v-flex xs10>
            <v-data-table
              :headers="headers"
              :items="suppliers"
              :items-per-page="50"
              item-key="id"
              sort-by="id"
              :sort-desc=true
              class="elevation-1"
              :search="search"
              :custom-filter="filterOnlyCapsText"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Suppliers</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="900px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">New Supplier</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                            </v-flex> 
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="editedItem.contactPerson" label="Contact Person"></v-text-field>
                            </v-flex> 
                            <v-flex xs12 sm6 md4>                              
                              <v-text-field v-model="editedItem.phone" label="Phone"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4>                              
                              <v-text-field v-model="editedItem.email" label="Email"></v-text-field>
                            </v-flex>   
                            <v-flex xs12 sm6 md4>                              
                              <v-text-field v-model="editedItem.website" label="Website"></v-text-field>
                            </v-flex>   
                            <v-flex xs12 sm6 md12>
                              <v-textarea v-model="editedItem.address"  :outlined="true"
                              :auto-grow="true" :clearable="true"
                              label="Address"></v-textarea>
                            </v-flex> 
                            <v-flex xs12 sm6 md12>
                              <v-textarea v-model="editedItem.explanation"  :outlined="true"
                              :auto-grow="true" :clearable="true"
                              label="Explanation"></v-textarea>
                            </v-flex>                                                                                                                                                                                                    
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
                <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
              </template> 
              <template v-slot:body.append>                    
              </template>             
              <template v-slot:item.action="{ item }">              
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>
                <v-icon                  
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
const API_URL = 'definitions/suppliers';
export default {
    components:{
      LeftMenu
    },
    data () {
    return {
      dialog: false,
      search: '',
      suppliers: [
        {     
          name: '',
          address: '',
          explanation: '',           
        },               
      ],
      editedIndex: -1,
      editedItem: {
        name: '',
        address: '',
        explanation: '',   
      },
      defaultItem: {
        name: '',
        address: '',
        explanation: '',  
      },
    }
  },
  computed: {
    headers () {
      return [
        { text: 'Company Name', align: 'left', sortable: true, value: 'name'},
        { text: 'Contact Person',  value: 'contactPerson'  },   
        { text: 'Phone',  value: 'phone'  },    
        { text: 'Email',  value: 'email'  },    
        { text: 'Website',  value: 'website'  },   
        { text: 'Explanation',  value: 'explanation'  },  
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Supplier' : 'Edit Supplier'
    },
  },
  created() {    
    this.getSuppliers();    
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    editItem (item) {
      this.editedIndex = this.suppliers.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.suppliers.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.suppliers.splice(index, 1);
        this.deleteSupplier(item);
      } 
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {        
        this.updateSupplier(this.editedItem);
      } else {
        this.addSupplier(this.editedItem);         
      }      
    },
    addSupplier(item){
      this.$axios.post(this.$apiurl + API_URL, {
        name: item.name,
        address: item.address,
        website: item.website,
        contactPerson: item.contactPerson,
        phone: item.phone,
        email: item.email,
        explanation: item.explanation,
      })
      .then(response => {        
        if (response.status === 201) {
          this.suppliers.push(this.editedItem);
          this.close();
        } 
      }).catch(error => {        
          console.log(error);
        }); 
    },
    updateSupplier(item){
      this.$axios.put(this.$apiurl + API_URL, {
        id: item.id,
        name: item.name,
        address: item.address,
        website: item.website,
        contactPerson: item.contactPerson,
        phone: item.phone,
        email: item.email,
        explanation: item.explanation,
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.suppliers[this.editedIndex], this.editedItem);
          this.close();
        }         
      }).catch(error => {        
          console.log(error);
        }); 
    },
    deleteSupplier(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getSuppliers(){     
      this.$axios.get(this.$apiurl + API_URL)
        .then(response => {
            this.suppliers = response.data
        }) 
        .catch(error => {        
          console.log(error);
        });                         
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
